
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('rect',{attrs:{"x":"5.25","y":"0.75","width":"13.5","height":"22.5","rx":"3","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"5.25","y1":"17.75","x2":"18.75","y2":"17.75","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])])
          )
        }
      }
    